import { useMemo } from 'react'

// eslint-disable-next-line react-hooks/exhaustive-deps
export const useShallowMemo = <T extends object>(obj: T) => useMemo(() => obj, [...Object.values(obj)])
